import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  IconButton,
  Popover,
  Typography,
} from '@material-ui/core';
import { HelpCircle } from 'react-feather';

const GeneralPopover = ({
  message = '',
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const openPopover = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const closePopover = () => setAnchorEl(null);

  return (
    <>
      <IconButton
        onMouseEnter={openPopover}
        onMouseLeave={closePopover}
      >
        <HelpCircle />
      </IconButton>
      <Popover
        id={open ? 'simple-popover' : undefined}
        open={open}
        onClose={closePopover}
        style={{
          pointerEvents: 'none',
        }}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <Typography style={{ padding: 3 }}>
          {message}
        </Typography>
      </Popover>
    </>
  );
};

GeneralPopover.propTypes = {
  message: PropTypes.string,
};

export default GeneralPopover;
